import { render, staticRenderFns } from "./transSheet.vue?vue&type=template&id=22f1a0a2"
import script from "./transSheet.vue?vue&type=script&lang=js"
export * from "./transSheet.vue?vue&type=script&lang=js"
import style0 from "./transSheet.vue?vue&type=style&index=0&id=22f1a0a2&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports